import { render } from "./ConsumptionDetail.vue?vue&type=template&id=7fe4e822&scoped=true"
import script from "./ConsumptionDetail.vue?vue&type=script&lang=js"
export * from "./ConsumptionDetail.vue?vue&type=script&lang=js"

import "./ConsumptionDetail.vue?vue&type=style&index=0&id=7fe4e822&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe4e822"]])

export default __exports__